import { MockRestCall } from "@/common/api/ApiResult.model";
import { RestCallsKey } from "../demo/rest.resolver";

// @ts-ignore
export const recommendations: Record<Partial<RestCallsKey>, MockRestCall> = {
  /*   "recommendations.set-status": {
    delay: 0,
    payload: () => true,
  },
  "recommendations.update-info-types": {
    delay: 0,
    payload: () => true,
  },
  "recommendations.get-info-types": {
    delay: 0,
    payload: async () => {
      const { SharedState } = await import("@/common/state");
      return SharedState.l0InfoTypes.value.slice(0, 3).map((d) => d.id);
    },
  }, */
  "recommendations.get-list": {
    delay: 2000,
    payload: () => {
      return [
        {
          id: "riskyUsers",
          info_type: "a9383d32-7694-4d84-b37c-79afb945505b",
          status: "undone",
        },
        {
          id: "riskyUsers",
          info_type: "707babad-231f-82bb-014c-8506d3dc784e",
          status: "undone",
        },
        {
          id: "newExposures",
          info_type: "a9383d32-7694-4d84-b37c-79afb945505b",
          status: "undone",
        },
        {
          id: "restrictDLP",
          info_type: "fd6a3357-4b1f-df40-d9f5-731e35302fe5",
          status: "undone",
        },
        {
          id: "protectAccounts",
          info_type: "a9383d32-7694-4d84-b37c-79afb945505b",
          status: "undone",
        },
        {
          id: "download",
          info_type: "fd6a3357-4b1f-df40-d9f5-731e35302fe5",
          status: "undone",
        },
        {
          id: "labeling",
          info_type: "fd6a3357-4b1f-df40-d9f5-731e35302fe5",
          status: "undone",
        },
      ];
    },
  },
  /*   "recommendations.update-strategy": {
    delay: 0,
    payload: () => {
     //
    },
  }, */
  /*   "recommendations.get-strategies": {
    delay: 0,
    payload: () => {
      return [
        {
          id: "educate",
          on: true,
        },
        {
          id: "manage",
          on: true,
          configure: {
            delegate: true,
            effort: "high",
          },
        },
        {
          id: "prevent",
          on: false,
          configure: {
            effort: "medium",
          },
        },
        {
          id: "zerotrust",
          on: false,
          configure: {
            effort: "medium",
          },
        },
        {
          id: "restrict",
          on: true,
          configure: {
            effort: "low",
          },
        },
      ];
    },
  }, */
};
